// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const TrashIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 58 58">
          <path fill="inherit" d="M19.775 23.562v25.375H16.15V23.562h3.625m0-1.812H16.15c-1 0-1.812.812-1.812 1.812v25.375c0 1 .812 1.812 1.812 1.812h3.625c1 0 1.812-.813 1.812-1.813V23.562c0-1-.81-1.812-1.812-1.812zm21.75 1.812v25.375H37.9V23.562h3.625m0-1.812H37.9c-1 0-1.812.812-1.812 1.812v25.375c0 1 .812 1.812 1.812 1.812h3.625c1 0 1.812-.813 1.812-1.813V23.562c0-1-.81-1.812-1.812-1.812zM30.65 23.562v25.375h-3.625V23.562h3.625m0-1.812h-3.625c-1 0-1.812.812-1.812 1.812v25.375c0 1 .812 1.812 1.812 1.812h3.625c1 0 1.812-.813 1.812-1.813V23.562c0-1-.81-1.812-1.812-1.812zm19.938-14.5h-9.062V5.437A5.445 5.445 0 0 0 36.088 0h-14.5a5.444 5.444 0 0 0-5.438 5.437V7.25H7.088a3.625 3.625 0 0 0-3.625 3.625V14.5a3.625 3.625 0 0 0 3.625 3.625V50.75c0 3.997 3.252 7.25 7.25 7.25h29c3.998 0 7.25-3.253 7.25-7.25V18.125a3.625 3.625 0 0 0 3.625-3.625v-3.625a3.625 3.625 0 0 0-3.625-3.625zM19.775 5.437c0-1 .813-1.812 1.812-1.812h14.5c1 0 1.812.813 1.812 1.812V7.25H19.774V5.437zM46.963 50.75a3.636 3.636 0 0 1-3.625 3.625h-29a3.636 3.636 0 0 1-3.625-3.625V16.312h36.25V50.75zm3.625-36.25h-43.5v-3.625h43.5V14.5z"/>
        </svg>
      )
    }
  </Icon>
);

export default TrashIcon;
